module.exports = __webpack_public_path__ + "img/svelte.19405d16.svg";